export type CustomFieldSetModel = {
  cache_key: number,
  entity_type: string,
  id: number,
  key: string,
  owner_id: number,
  owner_type: string,
  type?: string,
}

const state = {
  id: null,
  entity_type: '',
  key: '',
  owner_id: undefined,
  owner_type: '',
}

export type CustomFieldSetRequestOptions = {}

export const requiredFields = [
  { key: 'entity_type' },
  { key: 'owner_id' },
  { key: 'owner_type' },
]

export default state
